import { create } from 'zustand';

// Terminal AI key/provider errors that warrant a persistent banner (toast is
// already shown for the original action). Transient codes (rate-limited,
// network) are intentionally NOT in this set — those are short-lived and
// would just nag the user.
const PERSISTENT_CODES = new Set([
  'AI_KEY_INVALID',
  'AI_QUOTA_EXCEEDED',
  'AI_ALL_PROVIDERS_FAILED',
  'NO_AI_PROVIDER',
]);

export function isPersistentAiKeyError(code) {
  return PERSISTENT_CODES.has(code);
}

export const useAiKeyStatus = create((set) => ({
  lastError: null, // { code, provider, message, at } | null

  set: (err) => {
    if (!err || !err.code || !PERSISTENT_CODES.has(err.code)) return;
    set({
      lastError: {
        code: err.code,
        provider: err.provider || null,
        message: err.message || '',
        at: Date.now(),
      },
    });
  },

  clear: () => set({ lastError: null }),
}));
